export const GET_NOTICES = 'GET_NOTICES'
